


import {Component, Emit, Model, Prop, Vue} from 'vue-property-decorator';
import {AnswerFeedback, InteractiveObject, QuestionsAndAnswers} from '@/interfaces/entities/forest-game.interface';
import PopupService from "@/services/popup.service";

declare const jQuery: any;

@Component({})
export default class AppForestGameAnswer extends Vue {

  @Model('change', {default: null})
  public value!: string;

  @Prop({default: 0})
  public index!: number;

  @Prop({default: ''})
  public id!: string;

  @Prop({default: null})
  public answer!: QuestionsAndAnswers;

  @Prop({default: null})
  public interactiveObject!: InteractiveObject;

  @Prop({default: null})
  public feedback!: AnswerFeedback;

  @Prop({default: false})
  public disabled!: boolean;

  @Emit('change')
  public emitChange() {
    return this.isSelected ? this.id : null;
  }

  public isSelected: boolean = false;
  public asciiDecimal: number = 65;

  private popupService: PopupService = PopupService.getInstance();

  public updateInput(): void {
    this.emitChange();
  }

  public classes(): { [name: string]: boolean } {
    return {
      [this.interactiveObject.inputType]: true,
      'correct': !this.interactiveObject.isMoodQuestion && this.feedback && this.feedback.check.toString() === '1',
      'error': !this.interactiveObject.isMoodQuestion && this.feedback && this.feedback.check.toString() === '0'
    }
  }

  public enlargeImage(imageSrc: string): void {
    this.popupService.open('imagePreview', {imageSrc: imageSrc}).subscribe();
  }
}
